<!-- Toolbar -->
<div class="banner" role="banner">
    <app-banner-settings-menu [userConnected]="userConnected"></app-banner-settings-menu>
    <span class="title">Hub4B</span>
    @if (!!userConnected) {
        <app-organization-selector
            [visible]="organizationSelectionVisible"
            [organizations]="organizations"
            [defaultSelectedOrganization]="selectedOrganization"
            (organizationSelected)="onOrganizationSelected($event)"></app-organization-selector>

        @if (!!views) {
            <app-view-selector [views]="views" [defaultSelectedView]="selectedView" (viewSelected)="onViewSelected($event)"></app-view-selector>
        }
    }
    <div class="spacer"></div>
    <button mat-icon-button class="theme-button" (click)="onThemeChange()">
        @if (!isDarkMode) {
            <mat-icon>dark_mode</mat-icon>
        }

        @if (isDarkMode) {
            <mat-icon>light_mode</mat-icon>
        }
    </button>
    @if (!!userConnected) {
        <div class="profile-container">
            <app-user-profile [userConnected]="userConnected"></app-user-profile>
        </div>
        <app-banner-menu></app-banner-menu>
        <a class="banner-icon" [routerLink]="" (click)="logoff()" matTooltip="Se déconnecter" matTooltipPosition="below">
            <fa-icon [icon]="powerOffIcon"></fa-icon>
        </a>
    }
</div>

<div class="container">
    @if (!!userConnected) {
        <div class="menu-container">
            <app-application-menu
                [isOrganizationSelected]="selectedOrganization"
                [isViewSelected]="selectedView"
                [viewTypeSelected]="selectedView?.viewType"
                [isArchivedView]="selectedView?.isArchive"></app-application-menu>
        </div>
    }
    <div [ngClass]="{ 'main-container': !!userConnected, 'main-login': !!!userConnected }">
        <router-outlet></router-outlet>
    </div>
</div>

    <ngx-spinner name="main-spinner" [fullScreen]="true" type="timer" size="medium"></ngx-spinner>
